import { Injectable } from '@angular/core';
import { LogEntry } from '@timechef/core/logging';
import { Sink } from '@timechef/core/logging/sinks/sink';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { LogLevel } from 'src/environments/environment-config';
import { AppInsightsService } from '../../analytics/app-insights.service';

@Injectable({ providedIn: 'root' })
export class AppInsightsSink extends Sink {
  constructor(private appInsightsService: AppInsightsService) {
    super(environment.logging['appInsights']);
  }

  log(entry: LogEntry): Observable<void> {
    // Log to console
    switch (entry.logLevel) {
      case LogLevel.Debug:
      case LogLevel.Info:
      case LogLevel.Warn:
        this.appInsightsService.logTrace(entry.buildLogString());
        break;
      case LogLevel.Error:
      case LogLevel.Fatal:
        {
          const ex = new Error(entry.buildLogString());
          this.appInsightsService.logException(ex);
        }
        break;
      default:
        this.appInsightsService.logTrace(entry.buildLogString());
    }
    return of();
  }
}
